import { NotificationType } from "@gelsenwasser/react";
import { AxiosError } from "axios";
import { log } from "common/Logger";
import { FileUploadResponse, FileUploadRequest, ProjektDokument } from "domain/Types";
import { FormikErrors } from "formik";
import { UseMutateAsyncFunction } from "react-query";

type UseUploadFileHandlerReturnType = {
  handleUpload: (documentsArray: ProjektDokument[], formValueName: string) => (files: File[]) => void;
  handleDelete: (formDocumentsArray: ProjektDokument[], formValueName: string) => (indexToRemove: number) => void;
};

export const useUploadFileHandler = (
  sessionId: string,
  addNotification: (message: string, status: string, type?: NotificationType | undefined) => void,
  uploadFiles: UseMutateAsyncFunction<FileUploadResponse[], AxiosError<unknown>, FileUploadRequest, unknown>,
  setFieldValue: (
    field: string,
    value: unknown,
    shouldValidate?: boolean | undefined
  ) => Promise<void | FormikErrors<unknown>>
): UseUploadFileHandlerReturnType => {
  const handleUpload = (documentsArray: ProjektDokument[], formValueName: string) => async (acceptedFiles: File[]) => {
    return uploadFiles({ sessionId: sessionId, files: acceptedFiles })
      .then((uploadedFiles) => {
        console.log(uploadedFiles);
        log.debug("response", uploadedFiles);
        setFieldValue(formValueName, [...documentsArray, ...uploadedFiles]);
        log.debug("Finished setting formValue");
      })
      .catch((err) => {
        log.error(err, "");
        addNotification("Einige Dateien konnten leider nicht hochgeladen werden.", "Warnung", NotificationType.Alert);
      });
  };

  const handleDelete =
    (formDocumentsArray: ProjektDokument[], formValueName: string) => async (indexToRemove: number) => {
      const fileToDelete = formDocumentsArray[indexToRemove];
      log.debug(`Deleting file`, fileToDelete);
      setFieldValue(
        formValueName,
        formDocumentsArray.filter((_, idx) => idx !== indexToRemove)
      );
    };

  return {
    handleUpload,
    handleDelete,
  };
};
